import React from 'react';
import PropTypes from 'prop-types';

/*** components***/
import {lidOptionsList} from "../PlanArea/OptionList";
import {MainOption} from '../../../../components/buildcomponent/Options/MainOption';
import SourceLidDnD from './SourceLidDnD';

export const Lid  = (props) => {
    return (
        <div className="lid-step-2" >
            <div className="lid-icon-step-2">
                <div className="lid-icon-length-marking-step-2">L</div>
                <div className="lid-icon-height-marking-step-2">
                    <span>H</span>
                </div>
                <div className="lid-icon-icon-step-2">

                    <SourceLidDnD
                        id = {`id-${props.index}`}
                        sourceClass = {"class-for-detect"}
                        value = {props.value}
                        index = {props.index}
                        currentStep = {props.currentStep}
                    />

                </div>
                <div className="lid-icon-sagex-step-2">
                    <label htmlFor="" className="lid-icon-sagex-name-step-2">Sagex</label>
                    <input
                        type="checkbox"
                        data-input-lid = {props.dataInputLid}
                        data-input-number = {props.dataInputNumber}
                        className={"lid-icon-sagex-value-step-2"}
                        data-input-name = {props.dataInputName}
                        onChange={props.changeInputValue}
                        checked = {props.value}
                    />

                </div>
            </div>
            <div className="lid-options-step-2">
                <ul className={"lid-options-list-step-2"}>
                    {lidOptionsList.map((item, index) => {
                        return ( <MainOption
                            key = {item.optionName}
                            optionName = {item.optionName}
                            index = {index}
                            type = {item.type}
                            step={5}
                            value = {props.dataParams[item.dataInputName]}
                            dataInputNumber = {props.dataInputNumber}
                            changeInputValue = {props.changeInputValue}
                            dataInputName = {item.dataInputName}
                            dataInputLid = {props.dataInputLid}
                            gridTemplateColumns = {window.innerWidth > 480 ? "50% 50%" : "20% 80%"}
                            inputWidth  = {window.innerWidth > 480 ? "80%" : "159px"}
                            inputHeight  = {window.innerWidth > 480 ? "100%" : "33px"}
                        />)
                    })}
                </ul>
            </div>
            <div className="lid-delete-sign-step-2">
                <div onClick = {(e) => {props.index !==0 ? props.deleteLid(props.currentStep, props.index) : props.deleteFromPlan(props.currentStep, props.index)}}>
                  -
              </div>
            </div>
        </div>
    )
};

Lid.propTypes = {
    dataInputLid : PropTypes.bool,
    dataInputNumber : PropTypes.number,
    dataInputName : PropTypes.string.isRequired,
    changeInputValue : PropTypes.func.isRequired,
    deleteFromPlan : PropTypes.func,
    value : PropTypes.bool,
    dataParams : PropTypes.shape({
        height : PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.number
        ]).isRequired,
        length : PropTypes.oneOfType([
            PropTypes.number,
            PropTypes.string
        ]).isRequired
    }),
};



// WEBPACK FOOTER //
// ./src/containers/steps/BuildSteps/OptionsArea/Lid.js